export default {
  namespaced: true,

  getters: {
    search(state, getters) {
      return (data, search) => {
        let results = [];
        results = results.concat(
          getters.searchInProperties(data, search),
        );
        results = results.concat(
          getters.searchInEntityProperties(data, search),
        );
        results = results.concat(
          getters.searchInFieldRelations(data, search),
        );
        results = results.concat(
          getters.searchInFieldProperties(data, search),
        );

        if (!results.length) {
          return false;
        }

        return results;
      };
    },

    searchInProperties(
      state,
      getters,
      rootState,
      rootGetters,
    ) {
      return (data, search) => {
        const { id } = search;
        const { properties } = rootState.builder.data;

        if (!properties) {
          return [];
        }

        return Object.keys(properties)
          .filter((key) => properties[key] === id)
          .map((key) => {
            const label = rootGetters[
              'builder/property/label'
            ](key);
            return `Properties > ${label}`;
          });
      };
    },

    searchInEntityProperties(
      state,
      getters,
      rootState,
      rootGetters,
    ) {
      return (data, search) => {
        const { id } = search;
        const { entities } = rootState.builder.data;

        const response = [];

        if (entities) {
          entities.forEach((entity) => {
            if (entity && entity.properties) {
              const { properties } = entity;

              Object.keys(properties).forEach((key) => {
                if (properties[key] === id) {
                  const label = rootGetters[
                    'builder/entityProperty/label'
                  ](key);
                  response.push(
                    `Entities > ${
                      entity.name.singular
                    } > Properties > ${label}`,
                  );
                }
              });
            }
          });
        }

        return response;
      };
    },

    searchInFieldRelations(
      state,
      getters,
      rootState,
      rootGetters,
    ) {
      return (data, search) => {
        const { id } = search;
        const { entities } = rootState.builder.data;

        const response = [];

        if (entities) {
          entities.forEach((entity) => {
            if (entity && entity.fields) {
              entity.fields.forEach((field) => {
                if (field && field.relation) {
                  const { relation } = field;

                  Object.keys(relation).forEach((key) => {
                    if (relation[key] === id) {
                      const label = rootGetters[
                        'builder/fieldRelation/label'
                      ](field, key);
                      response.push(
                        `Entities > ${
                          entity.name.singular
                        } > Fields > ${
                          field.name.singular
                        } > Relation > ${label}`,
                      );
                    }
                  });
                }
              });
            }
          });
        }

        return response;
      };
    },

    searchInFieldProperties(
      state,
      getters,
      rootState,
      rootGetters,
    ) {
      return (data, search) => {
        const { id } = search;
        const { entities } = rootState.builder.data;

        const response = [];

        if (entities) {
          entities.forEach((entity) => {
            if (entity && entity.fields) {
              entity.fields.forEach((field) => {
                if (field && field.properties) {
                  const { properties } = field;

                  Object.keys(properties).forEach((key) => {
                    if (properties[key] === id) {
                      const label = rootGetters[
                        'builder/fieldProperty/label'
                      ](field, key);
                      response.push(
                        `Entities > ${
                          entity.name.singular
                        } > Fields > ${
                          field.name.singular
                        } > Properties > ${label}`,
                      );
                    }
                  });
                }
              });
            }
          });
        }

        return response;
      };
    },
  },
};
